import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { CaretakersListComponent } from 'src/app/modules/caretakers/pages/caretakers-list/caretakers-list.page';
var ɵ0 = {
    permissions: ['canReadPropertiesList']
};
var routes = [
    {
        path: 'list',
        component: CaretakersListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var CaretakersRoutingModule = /** @class */ (function () {
    function CaretakersRoutingModule() {
    }
    return CaretakersRoutingModule;
}());
export { CaretakersRoutingModule };
export { ɵ0 };
